// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"675e5c52","1340":"ced1f7f6","6821":"ed373b5e","6862":"6c532003","8358":"617058c8","9631":"1cbb8437"}[chunkId] + ".chunk.css";
};